module.exports = __webpack_public_path__ + "static/media/ISTJ.cc57010e.png";